import { render, staticRenderFns } from "./ReDashboard.vue?vue&type=template&id=13d8da88&"
import script from "./ReDashboard.vue?vue&type=script&lang=js&"
export * from "./ReDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports